"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _classLib = require("class-lib");
var _Header = _interopRequireDefault(require("../molecules/Header.js"));
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["header", "className", "children", "messageType"]; // @ts-check
/**
 * @param {{className?: string, [key: string]: any}} props
 */
var Message = function Message(props) {
  var header = props.header,
    className = props.className,
    children = props.children,
    messageType = props.messageType,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded);
  var classes = (0, _classLib.mixClass)(className, {
    info: messageType === "info",
    error: messageType === "error",
    success: messageType === "success",
    warning: messageType === "warning"
  }, "message");
  var thisHeader;
  if (header) {
    thisHeader = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header["default"], {
      children: header
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restProps), {}, {
    cssList: [{
      cssModule: ["message"],
      cssGroup: "semantic"
    }],
    className: classes,
    children: [thisHeader, children]
  }));
};
var _default = exports["default"] = Message;
module.exports = exports.default;